
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class SectionTitle extends Vue {
  @Prop()
  title!: string;
}
